import { getLogger } from "@goodgamestudios/logger";
import { CREATEJS_UTILITIES_LOGGER } from "../../../../../index";
import Rectangle = createjs.Rectangle;

export class AccessibilityImplementation {
    public errno: number = 0;
    public stub: boolean = false;

    private logger = getLogger(CREATEJS_UTILITIES_LOGGER + ".AccessibilityImplementation");

    public accDoDefaultAction(childID: number): void {
        this.logger.warn("AccessibilityImplementation.accDoDefaultAction is not implemented");
    }

    public accLocation(childID: number): any {
        this.logger.warn("AccessibilityImplementation.accLocation is not implemented");
        return null;
    }

    public accSelect(operation: number, childID: number): any {
        this.logger.warn("AccessibilityImplementation.accSelect is not implemented");
    }

    public get_accDefaultAction(childID: number): string {
        this.logger.warn("AccessibilityImplementation.get_accDefaultAction is not implemented");
        return "";
    }

    public get_accFocus(): number {
        this.logger.warn("AccessibilityImplementation.get_accFocus is not implemented");
        return 0;
    }

    public get_accName(childID: number): string {
        this.logger.warn("AccessibilityImplementation.get_accName is not implemented");
        return "";
    }

    public get_accRole(childID: number): number {
        this.logger.warn("AccessibilityImplementation.get_accRole is not implemented");
        return 0;
    }

    public get_accSelection(): Array<any> {
        this.logger.warn("AccessibilityImplementation.get_accSelection is not implemented");
        return [];
    }

    public get_accState(childID: number): number {
        this.logger.warn("AccessibilityImplementation.get_accState is not implemented");
        return 0;
    }

    public get_accValue(childID: number): string {
        this.logger.warn("AccessibilityImplementation.get_accValue is not implemented");
        return "";
    }

    public get_selectionActiveIndex(): any {
        this.logger.warn("AccessibilityImplementation.get_selectionActiveIndex is not implemented");
        return null;
    }

    public get_selectionAnchorIndex(): any {
        this.logger.warn("AccessibilityImplementation.get_selectionAnchorIndex is not implemented");
        return null;
    }

    public getChildIDArray(): number[] {
        this.logger.warn("AccessibilityImplementation.getChildIDArray is not implemented");
        return Array<number>(0);
    }

    public isLabeledBy(labelBounds: Rectangle): boolean {
        this.logger.warn("AccessibilityImplementation.isLabeledBy is not implemented");
        return false;
    }

}
